import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Form, Input, Modal, Pagination, Row, Space } from "antd";

import colorSyntax from "@toast-ui/editor-plugin-color-syntax";
import { Editor } from "@toast-ui/react-editor";

import partnersApi from "../apis/Partners.api";
import BoardChannelComment from "../components/channel/BoardChannelComment";
import EditNotice from "../components/channel/EditNotice";
import LinkComponent from "../components/layout/LinkComponent";

const EditBoard = () => {
	const editorRef = useRef(null);

	const user = useSelector((state) => state.auth.user);

	const [channelInfo, setChannelInfo] = useState({});

	const [myShow, setMyShow] = useState(false);

	const [showUnAnswer, setShowUnsAnswer] = useState(false);
	const pageSize = 3;
	const [offset, setOffset] = useState(0);
	const [allCount, setAllCount] = useState(0);
	const [currentPageNumber, setCurrentPageNumber] = useState(1);

	const [contentShow, setContentShow] = useState(false);
	const [contentTitle, setContentTitle] = useState("");

	const [commentList, setCommentList] = useState([]);

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	useEffect(() => {
		if (channelInfo) {
			setCommentList(channelInfo?.commentList);
			setContentTitle(channelInfo?.title ?? "");
		}
		// editorRef.current?.getInstance().setHTML("")
	}, [channelInfo]);

	/**
	 * 글쓰기 버튼 클릭
	 */
	const createContent = () => {
		setContentShow(!contentShow);
	};

	useEffect(() => {
		if (!showUnAnswer) {
			getInfo(offset);
		} else {
			unAnswerList(offset);
		}
	}, [offset]);

	const getInfo = async (offset) => {
		let param = {
			userId: user?.id,
			offset: offset ?? 0,
			pageSize: pageSize,
		};
		// 페이지네이션 값
		const res = await partnersApi.readChannel(param);
		if (res.code === 200) {
			setChannelInfo(res.result);
			setAllCount(res.result.totalCnt);
		}
	};

	/**
	 * 콘텐츠 등록 & 수정
	 * @param channel
	 * @returns {Promise<void>}
	 */
	const postContent = async (channel) => {
		let param = {
			id: channel.id,
			title: channel.title,
			content: channel.content,
			is_notice: channel.is_notice,
			created_by: user.id,
			updated_by: user.id,
		};
		if (channel.type === "create") {
			const res = await partnersApi.createContent(param);
			if (res.code === 200) {
				getInfo(offset);
			}
		} else {
			const res = await partnersApi.editContent(param);
			if (res.code === 200) {
				getInfo(offset);
			}
		}
	};

	const toolbarItems = [
		["heading", "bold", "italic", "strike"],
		["link", "code"],
		// ['table', 'link'],
		["hr"],
		["ul", "ol", "task"],
		// ['image'],
		// ['code'],
		["scrollSync"],
	];

	const handleCancel = () => {
		setContentTitle(channelInfo?.title ?? "");
		setContentShow(false);
	};

	const submitContent = () => {
		let content = editorRef?.current?.getInstance().getHTML();

		let param = {
			id: channelInfo.id,
			title: contentTitle,
			content: content,
			is_notice: false,
			created_by: user.id,
			updated_by: user.id,
			type: !channelInfo.id ? "create" : "edit",
		};
		postContent(param);
		setContentShow(false);
	};

	/**
	 * 미답변 확인하기
	 */
	const unAnswerList = async (offset) => {
		let param = {
			boardId: channelInfo?.id,
			offset: offset ?? 0,
			pageSize: 3,
		};
		const res = await partnersApi.readUnAnswer(param);
		if (res.code === 200) {
			setCommentList(res.result);
		}
		setShowUnsAnswer(true);
	};

	const handleUnAnswerButton = () => {
		setCurrentPageNumber(1);
		if (!showUnAnswer) {
			unAnswerList(offset);
			setAllCount(channelInfo?.unansweredCnt);
		} else {
			getInfo(offset);
			setAllCount(channelInfo?.totalCnt);
			setShowUnsAnswer(false);
		}
	};

	/**
	 * page 넘김
	 */
	const handleChangePagination = (pageNumber) => {
		const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
		setOffset(currOffset);
	};

	return (
		<div className="main-wrap">
			<LinkComponent />
			<div
				className={`channel-wrap`}
				style={{
					display: "flex",
					backgroundColor: "white",
				}}
			>
				<div className={`channel-contents`}>
					{/*<div className={`channel-head`}>*/}
					{/*    <img*/}
					{/*        src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${channelInfo?.id}.${channelInfo?.profile_img_type}`}*/}
					{/*        // src={`/assets/images/channel/doctor.png`}*/}
					{/*        className={`channel-img`}*/}
					{/*        onError={({currentTarget}) => {*/}
					{/*            currentTarget.onerror = null; // prevents looping*/}
					{/*            // currentTarget.style.display = "none";*/}
					{/*            currentTarget.src = `/assets/images/channel/basic.png`;*/}
					{/*        }}*/}
					{/*        alt={`채널 이미지`}*/}
					{/*    />*/}
					{/*    <h2 className={`channel-title`}>*/}
					{/*        {channelInfo?.nickname ?? "채널명"}*/}
					{/*    </h2>*/}
					{/*</div>*/}
					<div className={`channel-body`}>
						{/*{contentShow ? (*/}
						{/*    <div style={{display: "flex", gap: "0.5em"}}>*/}
						{/*        <h3 className={`body-title`}>*/}
						{/*            ✅*/}
						{/*        </h3>*/}
						{/*        <Input*/}
						{/*            type={`text`}*/}
						{/*            name={`content-title`}*/}
						{/*            placeholder={`제목을 입력해주세요.`}*/}
						{/*            value={contentTitle}*/}
						{/*            onChange={(e) => {*/}
						{/*                setContentTitle(e.target.value);*/}
						{/*            }}*/}
						{/*        />*/}
						{/*    </div>*/}
						{/*) : (*/}
						{/*    <h3 className={`body-title`}>*/}
						{/*        ✅ {channelInfo?.title}*/}
						{/*    </h3>*/}
						{/*)}*/}
						<div className={`body-contents`}>
							{contentShow ? (
								<Editor
									ref={editorRef}
									initialValue={channelInfo?.content || ""} // 글 수정 시 사용
									// initialValue={contentTitle.content || ""} // 글 수정 시 사용
									initialEditType="wysiwyg" // wysiwyg & markdown
									previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
									hideModeSwitch={true}
									theme={""} // '' & 'dark'
									usageStatistics={false}
									toolbarItems={toolbarItems}
									useCommandShortcut={true}
									plugins={[colorSyntax]}
									language="ko-KR"
									height={`800px`}
								/>
							) : (
								<div
									dangerouslySetInnerHTML={{
										__html: channelInfo?.content,
									}}
									style={{
										minHeight: "200px",
									}}
								/>
							)}
							{/*{contentList.map((item, idx) => (*/}
							{/*    <div key={`상품 추천 내역 ${idx}`}>*/}
							{/*        <p className={`contents-title`}>*/}
							{/*            {item.title}*/}
							{/*        </p>*/}
							{/*        <p>*/}
							{/*            {item.body}*/}
							{/*        </p>*/}
							{/*        <Link to={item.link}>*/}
							{/*            {item.link}*/}
							{/*        </Link>*/}
							{/*    </div>*/}
							{/*))}*/}
							<span
								style={{
									color: "#fe2b4b",
									fontSize: "0.8em",
								}}
							>
								링크 삽입 시에는 https:// 까지 전부 작성해주세요.
							</span>
							<span
								className={`commission-notice`}
								style={{ whiteSpace: "pre-wrap" }}
							>
								이 포스팅은 아이허브, 당영투게더 활동의 일환으로, 이에 따른
								일정액의 수수료를 제공받습니다.
							</span>
						</div>
						<div className={`body-comment`}>
							<Space>
								<span>
									댓글
									<span className={`comment-count`}>
										{channelInfo?.totalCnt}
									</span>
								</span>
								<Button
									size={`small`}
									className={`${showUnAnswer ? "edit-success-btn" : ""}`}
									onClick={handleUnAnswerButton}
								>
									{showUnAnswer ? "전체 답변 보기" : "미답변만 보기"}
								</Button>
							</Space>
							{!contentShow ? (
								<Button
									size={`small`}
									className={`write-comment`}
									onClick={createContent}
								>
									글쓰기
								</Button>
							) : (
								<Row
									align={"middle"}
									justify={"center"}
									style={{
										gap: "0.5em",
									}}
								>
									<Button size={"small"} onClick={handleCancel}>
										취소
									</Button>
									<Button
										size={"small"}
										className={`edit-success-btn`}
										onClick={submitContent}
									>
										작성 완료
									</Button>
								</Row>
							)}
						</div>
					</div>
					<div className={`channel-footer`}>
						{commentList?.map((item, idx) => (
							<div className={`comment-wrap`} key={`댓글 내용 ${idx}`}>
								<BoardChannelComment
									getInfo={getInfo}
									channelInfo={channelInfo}
									item={item}
									type={"edit"}
								/>
							</div>
						))}
						<Pagination
							className="report-pagination-wrap channel-pagination"
							showSizeChanger={false}
							current={currentPageNumber}
							pageSize={pageSize}
							total={allCount}
							onChange={handleChangePagination}
						/>
					</div>
				</div>
				{/* 공지사항 수정 */}
				<EditNotice
					channelInfo={channelInfo}
					postContent={postContent}
					getInfo={getInfo}
					user={user}
				/>
			</div>

			{/* 내가 쓴 글 찾기 */}
			<Modal
				title="내가 쓴 글 찾기"
				wrapClassName="order-detail-modal-wrap channel-modal"
				open={myShow}
				centered={true}
				onCancel={() => setMyShow(!myShow)}
				width="25%"
				cancelText={<span>취소</span>}
				okText={<span>조회</span>}
			>
				<Form layout={`vertical`}>
					<Form.Item
						label="휴대폰 번호 가운데 4자리"
						labelAlign="left"
						colon={false}
						required
					>
						<Input
							type={`text`}
							placeholder={`휴대폰 번호 가운데 4자리를 입력해주세요.`}
							required
						/>
					</Form.Item>
					<Form.Item
						label="비밀번호 4자리"
						labelAlign="left"
						colon={false}
						required
					>
						<Input
							type={`text`}
							placeholder={`비밀번호를 입력해주세요.`}
							required
						/>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};
export default EditBoard;
